import { ThemeConfig } from "antd/lib";
import { COLOR_VALUES } from "../lib/types/shared/enums";

//TEXTS
export const text = {
  heading: "1.5rem",
  sub_heading: "1.125rem",
  large: "1.125rem",
  normal: "1rem",
  sm: "0.875rem"
};

export const antdGlobalTheme: ThemeConfig = {
  token: {
    colorPrimary: COLOR_VALUES.ox_2_primary,
    borderRadius: 4
  },
  components: {
    Tabs: {
      colorPrimary: COLOR_VALUES.ox_2_black,
      inkBarColor: COLOR_VALUES.ox_2_primary,
      verticalItemMargin: "1px"
    },
    Layout: {
      colorBgLayout: "#14e0bb",
      colorBgHeader: "#fcba03",
      colorBgBase: "#e014aa",
      colorBgContainer: "#14e0bb"
    }
  }
};
